import { render } from "./BannerNotification.vue?vue&type=template&id=2ab59f6e"
import script from "./BannerNotification.vue?vue&type=script&lang=js"
export * from "./BannerNotification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__